/* eslint-disable no-nested-ternary */
import React from "react";
import InputCommon from "components/inputCommon";
import { useAlterarObservacao } from "services/api";
import { Skeleton } from "@mui/material";
import * as Styles from "./styles";
import * as IconsSVG from "../../../assets/iconsSVG";
import MaterialUI from "../../../material-UI";

interface Props {
  observacaoCliente: string | undefined;
  isLoading: boolean;
  visaoCorretor: boolean;
  idLeadCorretor: string | undefined;
  idLead: string | undefined;
}

export function IdentificacaoLead(props: Props) {
  const [observacao, setObservacao] = React.useState<string | undefined>(
    props.observacaoCliente
  );
  React.useEffect(() => {
    if (props.observacaoCliente) {
      setObservacao(props.observacaoCliente);
    }
  }, [props.isLoading]);
  const { mutate, isLoading } = useAlterarObservacao({
    idLeadCorretor: props.idLeadCorretor,
    body: { idLead: props.idLead, observacaoLead: observacao },
  });
  return (
    <>
      <Styles.Container>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <IconsSVG.TagLead />
          <p>Observação do lead</p>
        </div>
        {props.visaoCorretor ? (
          <>
            {!props.isLoading ? (
              <InputCommon
                isError={false}
                placeholder="Observação do lead"
                helperText=""
                value={observacao}
                isDisabled={false}
                type="observacao"
                maxLengthProps={800}
                label=""
                row={4}
                multiline
                onChange={(event: string) => {
                  setObservacao(event);
                }}
              />
            ) : (
              <>
                <Skeleton variant="rounded" width="100%" height="100px" />
              </>
            )}
            <Styles.Button
              className="transfer-btn"
              color="secondary"
              variant="contained"
              type="submit"
              disabled={isLoading}
              style={{ marginTop: 16 }}
              onClick={() => mutate()}
            >
              {isLoading ? <MaterialUI.CircularProgress /> : "Salvar"}
            </Styles.Button>
          </>
        ) : (
          <>
            <p style={{ color: "#A3A3A6", fontSize: 14, marginLeft: 16 }}>
              {props.observacaoCliente ?? `--`}
            </p>
          </>
        )}
      </Styles.Container>
    </>
  );
}
